import CategoryReportDisplayItem from 'components/cards/CategoryReportDisplayItem';
import { CategoryTopic } from 'interface/CategoryTopic'
import React from 'react'
import styles from 'styles/layout/CategoryReportsDisplaySection.module.sass'

interface CategoryReportsDisplaySectionProps {
    reports: CategoryTopic[];
}

/**
 * CategoryReportsDisplaySection component displays a list of reports within a specific category.
 *
 * @param reports - The reports to display in the section.
 * @returns The rendered CategoryReportsDisplaySection component.
 */
const CategoryReportsDisplaySection: React.FC<CategoryReportsDisplaySectionProps> = ({ reports }) => {

    return (
        <section className={styles['category-reports-display-section']}>
            {reports.map((report) => (
                <CategoryReportDisplayItem key={report.id} report={report} />
            ))}
        </section>
    )
}

export default CategoryReportsDisplaySection